import { Link, useNavigate } from 'react-router-dom';

export default function Process() {
  const plans = [
    {
      tag: '創業首選',
      tagColor: 'bg-orange-500',
      title: '青年創業專案',
      description: '針對18-45歲創業者，提供低利、免保人的優惠貸款',
      features: ['最高額度 1,200 萬', '100 萬以下免保人'],
      icon: 'ri-rocket-line',
      link: '/projects/youth-startup'
    },
    {
      tag: '中小企業',
      tagColor: 'bg-blue-600',
      title: '信保基金專案',
      description: '透過中小企業信用保證基金，協助獲得銀行融資信保',
      features: ['最高保證成數 9.5 成', '適用各類營運週轉', '降低擔保品要求'],
      icon: 'ri-shield-check-line',
      link: '/projects/credit-guarantee'
    },
    {
      tag: '設備升級',
      tagColor: 'bg-teal-500',
      title: '低碳智慧化補助',
      description: '鼓勵製造業導入智慧化設備或低碳轉型，政府提供補助款',
      features: ['購置設備最高補助 500 萬', '不需還款（補助款）', '可搭配融資方案'],
      icon: 'ri-leaf-line',
      link: '/projects/low-carbon'
    }
  ];

  const cases = [
    {
      tag: '青年創業',
      tagColor: 'bg-orange-500',
      title: '知名連鎖餐飲加盟',
      industry: '#加盟創業',
      description: '初期缺乏足夠擔保品，透過青創貸款成功取得資金。',
      result: '核貸 200 萬',
      detail: '利率 1.42%',
      icon: 'ri-store-2-line'
    },
    {
      tag: '製造業轉型',
      tagColor: 'bg-blue-600',
      title: '精密機械加工廠',
      industry: '#設備升級',
      description: '老舊設備托管更新，透過低碳補助搭配信保貸款。',
      result: '獲補助 500 萬 + 融資 1500 萬',
      detail: '',
      icon: 'ri-settings-3-line'
    },
    {
      tag: '文創產業',
      tagColor: 'bg-teal-500',
      title: '新銳設計工作室',
      industry: '#無形資產',
      description: '接案型企業，透過信保專案取得營運週轉金。',
      result: '核貸 300 萬',
      detail: '信保 9 成',
      icon: 'ri-palette-line'
    }
  ];

  const navigate = useNavigate();

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* 熱門資金方案 */}
        <div className="mb-32">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">熱門資金方案</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-orange-500 to-orange-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              針對不同產業與規模，精選最適合的政策與融資專案
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
            {plans.map((plan, index) => (
              <div
                key={index}
                className="bg-white rounded-xl border-2 border-gray-100 hover:border-orange-500/30 hover:shadow-xl transition-all duration-300 overflow-hidden group"
              >
                <div className={`h-1 ${plan.tagColor}`}></div>
                
                <div className="p-8">
                  <div className="flex items-center justify-between mb-6">
                    <span className={`${plan.tagColor} text-white text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap`}>
                      {plan.tag}
                    </span>
                    <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center group-hover:bg-orange-50 transition-colors">
                      <i className={`${plan.icon} text-2xl text-gray-400 group-hover:text-orange-500 transition-colors`}></i>
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{plan.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed min-h-[48px]">{plan.description}</p>

                  <div className="space-y-3 mb-8">
                    {plan.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start">
                        <i className="ri-checkbox-circle-fill text-teal-500 mt-0.5 mr-2 flex-shrink-0"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <Link 
                    to={plan.link}
                    onClick={() => window.scrollTo({ top: 0 })}
                    className="block w-full bg-gradient-to-r from-gray-800 to-black text-white py-3 rounded-lg font-semibold hover:from-gray-900 hover:to-gray-800 transition-all whitespace-nowrap cursor-pointer text-center"
                  >
                    方案詳情
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => window.scrollTo({ top: 0 }), 0);
              }}
              className="text-gray-600 hover:text-orange-500 font-semibold px-6 py-3 border-2 border-gray-200 hover:border-orange-500 rounded-lg transition-all whitespace-nowrap cursor-pointer inline-block"
            >
              查看全部方案
            </button>
          </div>
        </div>

        {/* 精選成功案例 */}
        <div className="bg-gray-50 -mx-6 lg:-mx-8 px-6 lg:px-8 py-20 rounded-3xl">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">精選成功案例</h2>
              <div className="w-20 h-1 bg-gradient-to-r from-orange-500 to-orange-600 mx-auto mb-6"></div>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                不只是數字，更是夢想與實現的故事。點擊查看我們如何協助客戶突破資金瓶頸
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
              {cases.map((caseItem, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300 overflow-hidden group"
                >
                  <div className={`h-1 ${caseItem.tagColor}`}></div>
                  
                  <div className="p-8">
                    <div className="flex items-center justify-between mb-4">
                      <span className={`${caseItem.tagColor} text-white text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap`}>
                        {caseItem.tag}
                      </span>
                      <span className="text-xs text-gray-500 font-medium">{caseItem.industry}</span>
                    </div>

                    <div className="flex items-start mb-4">
                      <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0 mr-3 group-hover:bg-orange-50 transition-colors">
                        <i className={`${caseItem.icon} text-xl text-gray-400 group-hover:text-orange-500 transition-colors`}></i>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 leading-tight">{caseItem.title}</h3>
                    </div>

                    <p className="text-gray-600 text-sm mb-6 leading-relaxed min-h-[40px]">
                      {caseItem.description}
                    </p>

                    <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-lg p-4 mb-6">
                      <div className="flex items-center justify-center mb-1">
                        <i className="ri-trophy-line text-orange-500 mr-2"></i>
                        <span className="text-xs text-gray-600 font-medium">成果重點</span>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-orange-600 mb-1">{caseItem.result}</div>
                        {caseItem.detail && (
                          <div className="text-sm text-gray-700 font-medium">{caseItem.detail}</div>
                        )}
                      </div>
                    </div>

                    <button className="w-full bg-white text-gray-700 py-3 rounded-lg font-semibold border-2 border-gray-200 hover:border-orange-500 hover:text-orange-500 transition-all whitespace-nowrap cursor-pointer">
                      查看完整過程
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button className="text-gray-600 hover:text-orange-500 font-semibold px-6 py-3 inline-flex items-center group cursor-pointer whitespace-nowrap">
                查看更多成功案例
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
